import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = unknown/loading, false = anonymous, object = logged in
  const [token, setToken] = useState(() => localStorage.getItem("mf_token") || "");

  const setSession = useCallback((nextToken, nextUser) => {
    if (nextToken) localStorage.setItem("mf_token", nextToken);
    else localStorage.removeItem("mf_token");
    setToken(nextToken || "");
    setUser(nextUser || false);
  }, []);

  const fetchMe = useCallback(async (tkn) => {
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        headers: tkn ? { Authorization: `Bearer ${tkn}` } : {},
        withCredentials: true,
      });
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (token) fetchMe(token);
    else setUser(false);
  }, [token, fetchMe]);

  const login = async (email, password) => {
    const { data } = await axios.post(
      `${API}/auth/login`,
      { email, password },
      { withCredentials: true }
    );
    setSession(data.token, data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (_) {}
    setSession("", false);
  };

  return (
    <AuthCtx.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);

export const authHeaders = () => {
  const t = localStorage.getItem("mf_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export { API };
